import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import AuthShell from '@/components/layout/AuthShell';
import { useAuth } from '@/context/AuthContext';

/** Catch-all route: a branded "page not found" with a way back. */
export default function NotFound() {
  const { pathname } = useLocation();
  const { user } = useAuth();

  return (
    <AuthShell variant="card" showTicker={false}>
      <div className="auth-card auth-card--wide">
        <div className="auth-head" style={{ marginBottom: 20 }}>
          <div className="auth-eyebrow">Error 404</div>
          <h1 className="auth-title">
            This page <em>doesn't exist.</em>
          </h1>
          <p className="auth-intro" style={{ maxWidth: 'none' }}>
            Nothing is published at{' '}
            <code className="t-meta" style={{ color: 'var(--text-primary)', overflowWrap: 'anywhere' }}>{pathname}</code>.
            Check the address, or continue from one of these pages.
          </p>
        </div>
        <div className="wl-cta-row" style={{ marginTop: 0 }}>
          {user ? (
            <Link to="/home" className="wl-btn wl-btn--primary">
              Go to your Inbox <ArrowRight aria-hidden="true" />
            </Link>
          ) : (
            <Link to="/" className="wl-btn wl-btn--primary">
              Go to the home page <ArrowRight aria-hidden="true" />
            </Link>
          )}
          {!user && <Link to="/login" className="wl-btn wl-btn--ghost">Sign in</Link>}
        </div>
      </div>
    </AuthShell>
  );
}
